exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icontuodong[data-v-348c39be]{cursor:pointer}.select-item[data-v-348c39be]{display:-webkit-box;display:-ms-flexbox;display:flex;border:1px dashed #fff;-webkit-box-sizing:border-box;box-sizing:border-box}.select-item .close-btn[data-v-348c39be]{cursor:pointer;color:#f56c6c}.select-item .el-input+.el-input[data-v-348c39be]{margin-left:4px}\n", ""]);

// exports
